import { useCallback, useState } from 'react';

export interface ExpandAllControlResult {
  isAllExpanded: boolean;
  commandExpanded: boolean;
  expandCommandSeq: number;
  toggleExpandAll: () => void;
  onChildExpandChange: (isExpanded: boolean) => void;
}

export function useExpandAllControl(): ExpandAllControlResult {
  const [commandExpanded, setCommandExpanded] = useState(false);
  const [expandCommandSeq, setExpandCommandSeq] = useState(0);
  const [openCount, setOpenCount] = useState(0);

  const toggleExpandAll = useCallback(() => {
    const nextCommandExpanded = openCount === 0;
    setCommandExpanded(nextCommandExpanded);
    setOpenCount(0);
    setExpandCommandSeq((seq) => seq + 1);
  }, [openCount]);

  const onChildExpandChange = useCallback((isExpanded: boolean) => {
    setOpenCount((prev) => (isExpanded ? prev + 1 : Math.max(0, prev - 1)));
  }, []);

  return {
    isAllExpanded: openCount > 0,
    commandExpanded,
    expandCommandSeq,
    toggleExpandAll,
    onChildExpandChange,
  };
}
